import React from 'react'
import { SpiralSpinner } from "react-spinners-kit"

export const LoadingComponent = ({text}) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-white">
            <img src="./logo_medicoinnovador_color.png" alt="Logo" width={"150px"} height={"150px"} className="w-48 mb-4" />
            <p className="text-lg text-gray-700 font-bold text-center">{text}...</p>
            <SpiralSpinner size={80} frontColor="#61dafb"  backColor="#00166f" loading={true} />
        </div>
    );
}

export default LoadingComponent;